import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../theme/ThemeContext';
import api from '../api';

export default function Layout() {
  const { user, logout } = useAuth();
  const { mode, toggle } = useTheme();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showChangePw, setShowChangePw] = useState(false);
  const [pwForm, setPwForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [pwMsg, setPwMsg] = useState('');
  const [pwSuccess, setPwSuccess] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const closeSidebar = () => setSidebarOpen(false);

  const openChangePw = () => {
    setPwForm({ current_password: '', new_password: '', confirm_password: '' });
    setPwMsg('');
    setPwSuccess(false);
    setShowChangePw(true);
  };

  const submitChangePw = async (e) => {
    e.preventDefault();
    setPwMsg('');
    if (pwForm.new_password !== pwForm.confirm_password) {
      setPwMsg('Las contraseñas nuevas no coinciden');
      return;
    }
    if (pwForm.new_password.length < 8) {
      setPwMsg('La nueva contraseña debe tener al menos 8 caracteres');
      return;
    }
    try {
      await api.post('/auth/change-password', {
        current_password: pwForm.current_password,
        new_password: pwForm.new_password,
      });
      setPwSuccess(true);
    } catch (err) {
      setPwMsg(err.response?.data?.detail || 'Error al cambiar la contraseña');
    }
  };

  return (
    <div className="app-layout">
      <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar} />
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={`${process.env.PUBLIC_URL}/logo-mark.png?v=2`} alt="Guali's Restaurants" className="sidebar-logo" />
          <div className="sidebar-brand">
            <div className="sidebar-brand-name">Inventario</div>
          </div>
        </div>
        <nav>
          <div className="nav-section">Resumen</div>
          <NavLink to="/" end onClick={closeSidebar}>Panel</NavLink>

          <div className="nav-section">Inventario</div>
          <NavLink to="/stores" onClick={closeSidebar}>Tiendas</NavLink>
          <NavLink to="/items" onClick={closeSidebar}>Artículos</NavLink>

          <div className="nav-section">Transacciones</div>
          <NavLink to="/purchases" onClick={closeSidebar}>Compras</NavLink>
          <NavLink to="/sales" onClick={closeSidebar}>Ventas</NavLink>
          <NavLink to="/waste" onClick={closeSidebar}>Merma / Desperdicio</NavLink>
          <NavLink to="/transfers" onClick={closeSidebar}>Transferencias</NavLink>

          <div className="nav-section">Conciliación</div>
          <NavLink to="/counting" onClick={closeSidebar}>Sesiones de Conteo</NavLink>
          <NavLink to="/reconciliations" onClick={closeSidebar}>Conciliaciones</NavLink>

          {user?.role === 'admin' && (
            <>
              <div className="nav-section">Administración</div>
              <NavLink to="/users" onClick={closeSidebar}>Usuarios</NavLink>
              <NavLink to="/audit-log" onClick={closeSidebar}>Registro de Auditoría</NavLink>
              <NavLink to="/admin-tools" onClick={closeSidebar}>Herramientas de Admin</NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <button className="theme-toggle" onClick={toggle} aria-label="Cambiar tema">
            <span>{mode === 'dark' ? '☀' : '☾'}</span>
            <span>{mode === 'dark' ? 'Modo claro' : 'Modo oscuro'}</span>
          </button>
          <div style={{ fontWeight: 600 }}>{user?.full_name}</div>
          <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 8 }}>{user?.role}</div>
          <button onClick={openChangePw} style={{ marginBottom: 6, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', padding: '4px 8px', borderRadius: 6 }}>Cambiar Contraseña</button>
          <button onClick={handleLogout}>Cerrar Sesión</button>
        </div>
      </aside>

      <div className="main-content">
        <div className="top-bar">
          <button className="hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
            &#9776;
          </button>
          <span>Guali's · Inventario</span>
          <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}>
            Cerrar Sesión
          </button>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </div>

      {showChangePw && (
        <div className="modal-overlay">
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Cambiar Contraseña</h2>
            {pwSuccess ? (
              <>
                <div className="alert alert-success">Contraseña cambiada exitosamente.</div>
                <div className="modal-actions">
                  <button className="btn btn-primary" onClick={() => setShowChangePw(false)}>Cerrar</button>
                </div>
              </>
            ) : (
              <form onSubmit={submitChangePw}>
                {pwMsg && <div className="alert alert-danger">{pwMsg}</div>}
                <div className="form-group">
                  <label>Contraseña Actual</label>
                  <input
                    type="password"
                    value={pwForm.current_password}
                    onChange={e => setPwForm({ ...pwForm, current_password: e.target.value })}
                    required
                    autoComplete="current-password"
                  />
                </div>
                <div className="form-group">
                  <label>Nueva Contraseña</label>
                  <input
                    type="password"
                    value={pwForm.new_password}
                    onChange={e => setPwForm({ ...pwForm, new_password: e.target.value })}
                    required
                    autoComplete="new-password"
                    minLength={8}
                  />
                </div>
                <div className="form-group">
                  <label>Confirmar Nueva Contraseña</label>
                  <input
                    type="password"
                    value={pwForm.confirm_password}
                    onChange={e => setPwForm({ ...pwForm, confirm_password: e.target.value })}
                    required
                    autoComplete="new-password"
                    minLength={8}
                  />
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowChangePw(false)}>Cancelar</button>
                  <button type="submit" className="btn btn-primary">Cambiar Contraseña</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
